import script from "./RouteLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./RouteLoader.vue?vue&type=script&setup=true&lang=ts"

import "./RouteLoader.vue?vue&type=style&index=0&id=5262fd4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5262fd4a"]])

export default __exports__